import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormsService } from '../../providers/forms.service';
import { ScrollService } from '../../providers/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../providers/firebase.service';
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { Location } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { AWSConnectorService } from '../../providers/aws-connector';
import 'rxjs/add/operator/first';

@Component({
  selector: 'app-location-portable-settings',
  templateUrl: './location-portable-settings.component.html',
  styleUrls: ['./location-portable-settings.component.css']
})
export class LocationPortableSettingsComponent implements OnInit, AfterViewInit {
  key: string;
  locKey: string;
  path: string;
  showLoading = true;
  hideGetChargesButton = false;
  charges = 'loading...';
  clientData: Client;
  locationData: LocationInfo;
  dropOffOptions = [
    { label: 'Driveway', value: 'Driveway' },
    { label: 'Sloped Driveway', value: 'Sloped Driveway' },
    { label: 'Side of Road', value: 'Side of Road' },
    { label: 'Parking Space', value: 'Parking Space' }
  ];
  deliveryTimeOptions = [
    { label: 'Morning', value: 'Morning' },
    { label: 'Afternoon', value: 'Afternoon' },
    { label: 'Evening', value: 'Evening' }
  ];

  constructor(
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    public router: Router,
    private awsConn: AWSConnectorService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.path = '/clients/' + this.key + '/locations/' + this.key + '/' + this.locKey;
      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.afService.getLocationInfo(this.key, this.locKey).subscribe(locationData => {
          this.clientData = clientData;
          this.locationData = locationData;
          if (isNullOrUndefined(this.locationData.portableInfo)) {
            this.locationData.portableInfo = {};
          }
          if (isNullOrUndefined(this.locationData.portableInfo.dropOffOptions)) {
            this.locationData.portableInfo.dropOffOptions = [];
          }
          if (isNullOrUndefined(this.locationData.portableInfo.deliveryTimeOptions)) {
            this.locationData.portableInfo.deliveryTimeOptions = [];
          }
          this.showLoading = false;
        });
      });
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  loadChargeTypes() {
    this.hideGetChargesButton = true;
    this.awsConn.getAllChargeTypes(this.clientData.code, this.locKey).first().subscribe((data: any) => {
      console.log(data);
      let tmp = '';
      for (let c of data) {
        tmp += `Charge Description: ${ c.sChgDesc }<br>Charge ID: ${ c.ChargeDescID }<br><br>`
      }
      this.charges = tmp;
    });
  }

  updateLocation() {
    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
      this.afService.openSnackBar('Location successfully updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-portable-settings/location-portable-settings.component.ts